export enum Manufacturer {
  Rch = 'RCH',
  Custom = 'CUSTOM',
  Epson = 'EPSON',
  ItalRetail = 'ITALRETAIL',
}
